module.exports = __webpack_public_path__ + "static/media/tick_icon.4c287d3c.svg";